<template>
  <div class="main" v-loading="$store.state.loading">
    <containerHeader ref="header"></containerHeader>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>
  
<script>


import containerHeader from "../components/container_header.vue"
export default {
  components: {
    containerHeader
  },
  data() {
    return {

    };
  },
  mounted() {
    this.$socket.open();
    this.sockets.subscribe("warning", (data) => {
      console.log(data);
    });
    this.sockets.subscribe("status", (data) => {
      this.$store.state.realTimeData = JSON.parse(data);
    });
  },
  sockets: {
    connecting() {
      console.log("正在连接");
    },
    disconnect() {
      console.log("Socket 断开");
    },
    connect_failed() {
      console.log("连接失败");
    },
    connect() {
      console.log("socket connected");
    },
  },
  methods: {

  },
  computed: {},
};
</script>
  
<style lang="less" scoped>
.main {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 15;
  overflow: auto;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: calc(100% - 4.375rem);
}

@media screen and (max-width: 1440px) {
  .content {
    width: 100%;
    height: calc(100% - 70px);
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/main.vue